import { Trans } from '@lingui/react'
import { bool } from 'prop-types'

import ButtonAsLink from 'views/components/molecules/ButtonAsLink'
import {
  getCountdown,
  shouldBeShippedToday,
  showFreeDeliveryLabel,
} from 'views/components/organisms/NowCountdown/helpers'

import 'views/components/organisms/NowCountdown/NowCountdown.scss'

const NowCountDown = ({ showCountDownPlaceholder }) => {
  const shipToday = shouldBeShippedToday() || showCountDownPlaceholder

  return (
    <p
      data-clientside-hook="now-countdown-wrapper"
      className="u-border--bottom u-color--gray-medium u-margin--top u-padding--bottom o-NowCountdown--wrapper"
    >
      <span
        data-clientside-hook="nowCountDownTodayText"
        aria-hidden={shipToday ? null : true}
        className="o-NowCountdown--text u-color--positive u-font-weight--bold"
      >
        {showFreeDeliveryLabel() && <>& kostenlose </>}
        Lieferung HEUTE
      </span>
      <span
        data-clientside-hook="nowCountDownTomorrowText"
        aria-hidden={shipToday ? true : null}
        className="o-NowCountdown--text u-color--positive u-font-weight--bold"
      >
        {showFreeDeliveryLabel() && <>& kostenlose </>}
        Lieferung MORGEN
      </span>{' '}
      <Trans
        id="nowCountdown.ifYouBuyInXMinutes"
        values={{
          countdown: (
            <span
              className="u-font-weight--bold o-NowCountdown--countdown"
              data-clientside-hook="now-countdown"
            >
              {showCountDownPlaceholder ? '--:--:--' : getCountdown()}
            </span>
          ),
        }}
      />{' '}
      <ButtonAsLink
        data-clientside-hook="countDownModalTrigger nowWidget"
        underlined
        name="countDownModalTrigger"
        inheritColor
        isClientsideControlled
      >
        <Trans id="general.label.seeDetails" />
      </ButtonAsLink>
    </p>
  )
}

NowCountDown.propTypes = {
  showCountDownPlaceholder: bool,
}

NowCountDown.defaultProps = {
  showCountDownPlaceholder: false,
}

export default NowCountDown
